import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Package, Target, ArrowRight } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FadeIn } from '../components/ui/FadeIn';
export function ProductosPage() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-neutral-950 text-white selection:bg-red-500/30 selection:text-white overflow-x-hidden" data-id="element-521">
      <Navbar data-id="element-522" />

      <main data-id="element-523">
        {/* HERO */}
        <section className="relative pb-20 md:pb-24 bg-neutral-950 border-b border-neutral-900" style={{
        paddingTop: 'calc(var(--header-height) + 80px)'
      }} data-id="element-524">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,#0a0a0a_80%)] pointer-events-none" data-id="element-525" />
          <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-526">
            <FadeIn data-id="element-527">
              <span className="text-xs font-bold tracking-[0.2em] text-red-500 uppercase mb-4 block" data-id="element-528">
                Catálogo
              </span>
              <h1 className="text-4xl sm:text-5xl md:text-7xl font-black tracking-tighter text-white mb-6 uppercase" data-id="element-529">
                Productos
                <br data-id="element-530" />
                <span className="text-transparent bg-clip-text bg-gradient-to-b from-white to-neutral-500" data-id="element-531">
                  Protocolo Sniper
                </span>
              </h1>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-532">
              <p className="text-lg md:text-xl text-neutral-300 max-w-2xl mx-auto text-balance" data-id="element-533">
                Elegí tu entrada. Si querés el camino completo, la{' '}
                <a href="#/mentoria" className="text-white font-medium border-b border-red-600 hover:text-red-400 transition-colors" data-id="element-534">
                  Mentoría
                </a>{' '}
                lo incluye todo.
              </p>
            </FadeIn>
          </div>
        </section>

        {/* PRODUCTOS */}
        <section className="py-24 md:py-32 bg-neutral-900 border-b border-neutral-800" data-id="element-535">
          <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-536">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-537">
              {/* Card 1 — Ebook */}
              <FadeIn delay={0.1} data-id="element-538">
                <div className="bg-[#121212] border border-neutral-800 p-8 md:p-10 rounded-sm flex flex-col h-full" data-id="element-539">
                  <div className="w-12 h-12 bg-neutral-900 border border-neutral-800 flex items-center justify-center rounded-sm mb-6" data-id="element-540">
                    <BookOpen className="w-6 h-6 text-red-500" data-id="element-541" />
                  </div>
                  <h2 className="text-2xl font-black text-white uppercase tracking-tight mb-3" data-id="element-542">
                    Ebook Protocolo Sniper OTC
                  </h2>
                  <p className="text-neutral-400 text-sm leading-relaxed mb-6 flex-1" data-id="element-543">
                    Acceso inmediato. Descarga digital. El manual operativo
                    completo del sistema Sniper para mercados OTC.
                  </p>
                  <div className="mb-6 pb-6 border-b border-neutral-800" data-id="element-544">
                    <div className="flex items-baseline gap-3" data-id="element-545">
                      <span className="text-3xl font-black text-white" data-id="element-546">
                        ARS 39.999
                      </span>
                    </div>
                    <p className="text-xs text-neutral-500 mt-1" data-id="element-547">
                      Precio relanzamiento (luego vuelve a ARS 90.000)
                    </p>
                  </div>
                  <a href="https://protocolosniperotc.com/products/protocolosniper?variant=43460889903182" target="_blank" rel="noopener noreferrer" className="w-full bg-red-600 hover:bg-red-500 text-white font-bold py-4 px-6 rounded-sm transition-all text-center uppercase tracking-wider text-sm flex items-center justify-center gap-2" data-id="element-548">
                    Ver / Comprar Ebook
                    <ArrowRight className="w-4 h-4" data-id="element-549" />
                  </a>
                </div>
              </FadeIn>

              {/* Card 2 — Pack */}
              <FadeIn delay={0.2} data-id="element-550">
                <div className="bg-[#121212] border border-neutral-800 p-8 md:p-10 rounded-sm flex flex-col h-full" data-id="element-551">
                  <div className="w-12 h-12 bg-neutral-900 border border-neutral-800 flex items-center justify-center rounded-sm mb-6" data-id="element-552">
                    <Package className="w-6 h-6 text-red-500" data-id="element-553" />
                  </div>
                  <h2 className="text-2xl font-black text-white uppercase tracking-tight mb-3" data-id="element-554">
                    Pack Ebook + Lenguaje de Precio
                  </h2>
                  <p className="text-neutral-400 text-sm leading-relaxed mb-6 flex-1" data-id="element-555">
                    Para desarrollar criterio y lectura con una ruta más
                    completa. Incluye el Ebook Sniper OTC + Clase de
                    introduccion al Lenguaje de Precio.
                  </p>
                  <div className="mb-6 pb-6 border-b border-neutral-800" data-id="element-556">
                    <div className="flex items-baseline gap-3" data-id="element-557">
                      <span className="text-3xl font-black text-white" data-id="element-558">
                        ARS 119.999
                      </span>
                    </div>
                    <p className="text-xs text-neutral-500 mt-1" data-id="element-559">
                      Precio relanzamiento (luego vuelve a ARS 250.000)
                    </p>
                  </div>
                  <a href="https://protocolosniperotc.com/products/pack-protocolo-sniper-introduccion-al-lenguaje-de-precio" target="_blank" rel="noopener noreferrer" className="w-full bg-red-600 hover:bg-red-500 text-white font-bold py-4 px-6 rounded-sm transition-all text-center uppercase tracking-wider text-sm flex items-center justify-center gap-2" data-id="element-560">
                    Ver / Comprar Pack
                    <ArrowRight className="w-4 h-4" data-id="element-561" />
                  </a>
                </div>
              </FadeIn>
            </div>

            {/* Card 3 — Mentoría (destacada, full width) */}
            <FadeIn delay={0.3} data-id="element-562">
              <div className="mt-8 bg-[#0f0f0f] border border-red-600/30 p-8 md:p-12 rounded-sm relative overflow-hidden shadow-[0_0_60px_rgba(220,38,38,0.05)]" data-id="element-563">
                <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-red-600 to-transparent" data-id="element-564" />
                <div className="absolute top-4 right-4 bg-red-600 text-white text-[10px] font-bold px-3 py-1 uppercase tracking-widest rounded-sm z-10" data-id="element-565">
                  Programa Completo
                </div>

                <div className="flex flex-col md:flex-row md:items-center gap-8" data-id="element-566">
                  <div className="flex-1" data-id="element-567">
                    <div className="w-12 h-12 bg-neutral-950 border border-neutral-800 flex items-center justify-center rounded-sm mb-6" data-id="element-568">
                      <Target className="w-6 h-6 text-red-500" data-id="element-569" />
                    </div>
                    <h2 className="text-3xl md:text-4xl font-black text-white uppercase tracking-tight mb-3" data-id="element-570">
                      Mentoría Privada Protocolo Sniper
                    </h2>
                    <p className="text-neutral-300 text-sm md:text-base leading-relaxed mb-4" data-id="element-571">
                      3 meses de acompañamiento intensivo. Todo el sistema +
                      correcciones + comunidad. Sin dependencia.
                    </p>

                    <div className="inline-flex items-center gap-2 bg-red-600/10 border border-red-600/20 px-3 py-1.5 rounded-sm mb-6" data-id="element-572">
                      <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse" data-id="element-573" />
                      <span className="text-xs font-bold tracking-[0.2em] text-red-500 uppercase" data-id="element-574">
                        Inicio: Abril 2026 — Cupos limitados
                      </span>
                    </div>
                  </div>

                  <div className="md:text-right shrink-0" data-id="element-575">
                    <div className="mb-2" data-id="element-576">
                      <span className="text-4xl font-black text-white" data-id="element-577">
                        USD 500
                      </span>
                      <p className="text-xs text-neutral-500 mt-1" data-id="element-578">
                        Precio estándar
                      </p>
                    </div>
                    <div className="mb-6 pb-6 border-b border-neutral-800" data-id="element-579">
                      <span className="text-2xl font-black text-red-400" data-id="element-580">
                        USD 399
                      </span>
                      <p className="text-xs text-neutral-500 mt-1" data-id="element-581">
                        Precio alumno (validando compra previa)
                      </p>
                    </div>
                    <button onClick={() => navigate('/mentoria')} className="bg-red-600 hover:bg-red-500 text-white font-bold py-4 px-10 rounded-sm transition-all text-center uppercase tracking-wider text-sm shadow-[0_0_20px_rgba(220,38,38,0.3)] w-full md:w-auto cursor-pointer" data-id="element-582">
                      Ver Mentoría
                    </button>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </section>

        {/* LEGAL DISCLAIMER */}
        <section className="py-16 bg-neutral-950" data-id="element-583">
          <div className="max-w-3xl mx-auto px-6 md:px-12 text-center" data-id="element-584">
            <FadeIn data-id="element-585">
              <div className="text-xs text-neutral-600 leading-relaxed space-y-1" data-id="element-586">
                <p data-id="element-587">
                  Contenido estrictamente educativo. No es asesoramiento
                  financiero.
                </p>
                <p data-id="element-588">
                  Operar en los mercados financieros conlleva un alto riesgo.
                  Los resultados varían según cada individuo.
                </p>
              </div>
            </FadeIn>
          </div>
        </section>
      </main>

      <Footer data-id="element-589" />
    </div>;
}